<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <div class="text-h5">Your Events</div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-data-table
                    :headers="headers"
                    :items="events"
                    class="multi-connect-table"
                    @click:row="handleRowClick"
                    :items-per-page="8"
                >
                  <template v-slot:item.displayImageURL="{ item }">
                    <UserAvatar
                        v-if="item.name || item.displayImageURL"
                        :usersInitials="item.name[0]"
                        :displayImageUrl="item.displayImageURL"
                    />
                    <v-sheet
                        v-else
                        flat
                        class="badge-image circle d-flex justify-center align-center"
                        :height="50"
                        :width="50"
                    >
                      <v-sheet
                          :class="[
                                    'circle d-flex justify-center align-center dashed-border',
                                    ]"
                          :height="50"
                          :width="50"
                      >
                        <div class="grey--text text-center logo-text">
                          Add your logo
                        </div>
                      </v-sheet>
                    </v-sheet>
                  </template>

                  <template v-slot:item.name="{ item }">
                    {{ getMultiConnectEventName(item) }}
                    <br/>
                    <div class="text-capitalize text-caption">
                      {{ item.type }}
                    </div>
                  </template>
                  <template slot="no-data">
                    <div>You don't have any events</div>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                        label
                        :color="item.getStatusColor()"
                        :textColor="item.getStatusTextColor()"
                        class="font-weight-medium"
                        dark
                        small
                    >{{ item.getStatus() }}
                    </v-chip
                    >
                  </template>


                  <template v-slot:item.eventDateTime="{ item }">
                    <div>
                      <div>
                        <div class="text--secondary">Start:</div>
                        <div>
                          {{ getEventStartDateTime(item) }}
                        </div>
                      </div>
                      <br/>
                      <div>
                        <div class="text--secondary">End:</div>
                        <div>
                          {{ getEventEndDateTime(item) }}
                        </div>
                      </div>
                    </div>
                  </template>

                  <template v-slot:item.type="{ item }">
                    <span class="text-capitalize">{{ item.type }}</span>
                  </template>

                  <template v-slot:item.createdBy="{ item }">
                                <span class="text-capitalize text-no-wrap">{{
                                    item.createdBy
                                  }}</span
                                >&nbsp;<span
                      v-if="item.createdAt != null"
                      class="text-capitalize"
                  >{{ item.createdAt.toLocaleDateString() }}</span
                  >
                  </template>

                  <template v-slot:item.action="{ item }">
                    <!-- <v-menu transition="slide-y-transition" bottom left offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                                </template>
                                <v-list nav>
                                <v-list-item @click="handleEdit(item)">
                                    <v-list-item-title>Edit event</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="copyLink(item)" v-if="item.linkPrivacy == 'Public'">
                                    <v-list-item-title>Copy event link</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="viewAttendees(item)">
                                    <v-list-item-title>View registrants</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="viewInvitees(item)">
                                    <v-list-item-title>View invitees</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="showConfirmation(item)">
                                    <v-list-item-title>Delete Event</v-list-item-title>
                                </v-list-item>
                                </v-list>
                            </v-menu> -->

                    <SubMenu
                        name="New Menu"
                        :data="item"
                        :menu-items="fileMenuItems"
                        @sub-menu-click="onMenuItemClick"
                        :isOpenOnHover="false"
                    />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Event from "@/models/Event";
import UserAvatar from "@/components/UserAvatar";
import {eventDocRef, getEventDoc} from "@/shared/firebase_utils";

export default {
  components: {
    UserAvatar,
  },
  computed: {
    ...mapGetters([
      "businessProfile",
    ]),
  },
  data() {
    return {
      events: [],
      headers: [
        {
          text: "",
          value: "displayImageURL",
          align: "start",
        },
        {
          text: "Event Name",
          value: "name",
          align: "start",
        },
        {text: "Status", value: "status", align: "start"},

        {
          text: "Event Date and Time",
          value: "eventDateTime",
          align: "start",
        },

        // {
        //   text: "Date",
        //   value: "createdAt",
        //   align: "start",
        // },
      ],
    };
  },
  created() {
    this.retrieveEvent();
  },
  methods: {
    handleRowClick(item) {
      try {
        console.log("Navigating to manageEvent");
        this.$router.push({name: "ManageEventForPartner", params: {eventId: item.id}});
        console.log("After navigating to manageEvent");
      } catch (error) {
        console.log("Error in handleRowClick:", error);
      }

    },
    async retrieveEvent() {
      try {
        this.events = [];
        const docId = this.businessProfile.partnerRepresentativeParentEventId;
        if (docId) {
          const docSnapshot = await getEventDoc(docId);
          if (docSnapshot.exists) {
            const event = Event.fromFireStore(docSnapshot); // Convert to Event model
            this.events.push(event);
          }
        }
      } catch (error) {
        console.log("Error in retrieveEvent:", error);
      }
    },
    getEventActivationDateTime(item) {
      if (item.getFormattedEventActivationDateTime())
        return (
            item.getFormattedEventActivationDateTime() +
            " (" +
            item.timezone +
            ")"
        );
      else return "-";
    },
    getEventExpirationDateTime(item) {
      if (item.getFormattedEventExpirationDateTime())
        return (
            item.getFormattedEventExpirationDateTime() +
            " (" +
            item.timezone +
            ")"
        );
      else return "-";
    },
    getEventStartDateTime(item) {
      if (item.getFormattedEventStartDate())
        return item.getFormattedEventStartDate() + " (" + item.timezone + ")";
      else return "-";
    },
    getEventEndDateTime(item) {
      if (item.getFormattedEventEndDate())
        return item.getFormattedEventEndDate() + " (" + item.timezone + ")";
      else return "-";
    },
    getMultiConnectEventName(item) {
      if (item.name) return item.name;
      else return "Untitled Event";
    },
  },
};
</script>

